export default __webpack_public_path__ + "static/media/Photographs5.fef39e9a.png";